import { CircularProgress } from '@mui/material';
import { HeaderMedium } from '@core-web/typography';
import * as S from './Circular.styled';

export interface ICircularLoader {
  size?: number;
  statusMessage?: string;
}

const CircularLoader = ({ size = 120, statusMessage }: ICircularLoader): JSX.Element => (
  <S.Wrapper>
    <S.InnerWrapper>
      <CircularProgress size={size} color='inherit' />
      {statusMessage && (
        <S.LoadingStatusWrapper>
          <HeaderMedium title={statusMessage} />
        </S.LoadingStatusWrapper>
      )}
    </S.InnerWrapper>
  </S.Wrapper>
);

export default CircularLoader;
